/**
 * Reads the iOS safe-area inset from a CSS env() variable mounted on the root.
 * Falls back to 0 when not in a notched browser.
 */
export function safeAreaInsets(): { top: number; right: number; bottom: number; left: number } {
  const root = document.documentElement;
  const get = (name: string) => {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    if (!v) return 0;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };
  return {
    top: get("--sai-top"),
    right: get("--sai-right"),
    bottom: get("--sai-bottom"),
    left: get("--sai-left"),
  };
}

export function installSafeAreaVars(): void {
  const style = document.createElement("style");
  style.textContent = `
    :root {
      --sai-top: env(safe-area-inset-top, 0px);
      --sai-right: env(safe-area-inset-right, 0px);
      --sai-bottom: env(safe-area-inset-bottom, 0px);
      --sai-left: env(safe-area-inset-left, 0px);
    }
  `;
  document.head.appendChild(style);
}
